import type { VFrameBase } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'
import { createContext, useContext } from 'react'

type FrameContextType<F> = {
  frame: Optional<F>
  fieldVFrame: (name: string) => Optional<VFrameBase>
}

const FrameContext = createContext<FrameContextType<unknown> | null>(null)

const useFrameContext = <F>() => {
  const context = useContext(FrameContext)

  return (context ?? {}) as Partial<FrameContextType<F>>
}
const Provider = FrameContext.Provider

export { Provider, useFrameContext }
